
import { LDAPAddress } from "@/store/ldap-management/types";
import { Component, Vue, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { maxLength, minLength, required, url } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";

// Namespaces
const LDAPManagement = namespace("ldapManagement");

@Component({
	mixins: [validationMixin],
	validations: {
		ldapAddress: {
			address: {
				required,
				url,
				minLength: minLength(1),
				maxLength: maxLength(250)
			}
		}
	}
})
export default class AddNewLDAPAddress extends Vue {
	// Vuex
	@LDAPManagement.Getter("getLDAPAddesses") private ldapAddresses: LDAPAddress[];

	// Properties
	public ldapAddress: LDAPAddress = { address: "" };
	private hasAddressValidationErrors: boolean = false;
	private isFirstChangeMade: boolean = false;

	public onSave() {
		if (!this.$v.$invalid && !this.hasAddressValidationErrors) {
			this.$emit("save", this.ldapAddress);
		}
	}

	public onCancel() {
		this.hasAddressValidationErrors = false;
		this.$emit("cancel");
	}

	private triggerValidation(): void {
		this.isFirstChangeMade = true;
		this.hasAddressValidationErrors = this.ldapAddresses.some(x => x.address == this.ldapAddress.address);
	}

	private getError(): string {
		var errorText = "";
		let element = this.$v.ldapAddress.address;
		if (this.hasAddressValidationErrors) {
			errorText = "Similar item already exists";
		} else if (element.url) {
			errorText = "Invalid format of url";
		} else if (element.required) {
			errorText = "Invalid format of url";
		} else if (element.minLength) {
			errorText = "Min length is 1";
		} else if (element.maxLength) {
			errorText = "Max length is 250";
		}
		return errorText;
	}
}
